import { Entity } from '@core/data/dto/entity';
import { copyObjectProperties } from '@core/utils/object';
import { DtoForceConstructor } from '@core/utils/dto';
import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { EmployeeLeaveBalanceStatus } from './employee-leave-balance-status';
import { EmployeeLeaveBalanceSchema } from './employee-leave-balance.schema';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoType } from '@core/data/dto/dto-types';

@DtoForceConstructor
export class EmployeeLeaveBalance implements Entity {
    public id: string;
    public accrued: number;
    public accruedYtd: number;
    public balance: number;
    public deducted: number;
    public status: EmployeeLeaveBalanceStatus;
    public timeoffCode: string;
    public timeoffName: string;


    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(EmployeeLeaveBalanceSchema)
    static import(dto: Dto): any {
        return new EmployeeLeaveBalance(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeLeaveBalanceSchema,
        },
    ])
    export(type?: DtoType): any {}
}
